import { render, staticRenderFns } from "./forcedDelivery.vue?vue&type=template&id=4a0f2f0a&scoped=true&"
import script from "./forcedDelivery.vue?vue&type=script&lang=js&"
export * from "./forcedDelivery.vue?vue&type=script&lang=js&"
import style0 from "./forcedDelivery.vue?vue&type=style&index=0&id=4a0f2f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0f2f0a",
  null
  
)

export default component.exports